
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 24.011c-.827 0-1.5-.673-1.5-1.5v-18c0-.17.058-.336.164-.469l3-3.75c.14-.174.353-.274.586-.274s.446.1.586.274l3 3.75A.754.754 0 019 4.511v18c0 .827-.673 1.5-1.5 1.5H3zm0-1.5h4.5v-9.439l-4.5 4.5v4.939zm0-7.061l4.5-4.5V7.821l-4.5 4.5v3.129zm0-5.25l4.5-4.5v-.926L5.25 1.961 3 4.774V10.2zM12 24.011c-.827 0-1.5-.673-1.5-1.5V6.761c0-.161.053-.321.15-.45l2.25-3c.137-.183.361-.292.6-.292s.463.109.6.292l2.25 3c.097.129.15.289.15.45v15.75c0 .827-.673 1.5-1.5 1.5h-3zm0-1.5h3v-7.189l-3 3v4.189zm0-6.311l3-3v-3.129l-3 3V16.2zm0-5.25l3-3v-.939l-1.5-2-1.5 2v3.939zM19.5 24.011c-.827 0-1.5-.673-1.5-1.5v-13.5c0-.148.043-.292.126-.416l1.5-2.25c.135-.203.368-.324.624-.324s.489.121.624.324l1.5 2.25a.743.743 0 01.126.416v13.5c0 .827-.673 1.5-1.5 1.5h-1.5zm0-1.5H21v-4.939l-1.5 1.5v3.439zm0-5.561l1.5-1.5v-3.129l-1.5 1.5v3.129zm0-5.25l1.5-1.5v-.962l-.75-1.125-.75 1.125V11.7z"}})])
          )
        }
      }
    